import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useHistory } from '@atlassian/mpac-ui';
import { useCallback } from 'react';

import type { AnalyticsEvent } from '@atlassian/mpac-analytics';

const useCTAClickHandler = () => {
  const history = useHistory();
  const fireEvent = useAnalyticsEvents();

  return useCallback(
    (
      event: React.MouseEvent<Element, MouseEvent>,
      eventType: AnalyticsEvent,
      actionSubjectId: string,
      attributes: Record<string, string | undefined>,
      destinationUrl?: string
    ) => {
      event.preventDefault();
      fireEvent({
        eventType,
        actionSubjectId,
        attributes,
      });
      if (destinationUrl) {
        history?.push(destinationUrl);
      }
    },
    [history, fireEvent]
  );
};
export default useCTAClickHandler;
